<template>
    <div> <!-- class="_print-items-configurator _productitem-configurator-singlephoto" -->

        <!-- TODO: la descrizione prodotto andrebbe nel componente ConfigureProduct.vue -->
        <div class="row">
            <div class="col-md-12">
                <section class="print-product-intro justify-content-between"> <!-- _prod-desc--header -->
                    <div>
                        <router-link :to="{ name: 'choose-product'}" class="view-btn view-btn--back">
                            {{ $t('pages.configure_product.back') }}
                        </router-link>
                        <!--                        <router-link class="prod-desc&#45;&#45;header&#45;&#45;back-link" :to="{ name: 'choose-product'}">-->
                        <!--                            {{ $t('pages.configure_product.back') }}-->
                        <!--                        </router-link>-->

                        <header class="print-product__heading">
                            <div class="print-product__eyebrow">{{ selectedProduct.family_name }}</div>
                            <h2 class="print-product__title">{{ productTitle }}</h2>
                            <div class="print-product__subtitle">{{ selectedProduct.subtitle }}</div>
                        </header>

                        <div class="print-product__image-container d-md-none">
                            <img class="box-shadow img-fluid rounded" :src="productCoverImage">
                        </div>

                        <div class="print-product__description">
                            <vue-markdown>{{ selectedProduct.description }}</vue-markdown>
                        </div>

                        <button v-if="!hasProductItems" class="btn btn-primary" @click="showPhotoChooser">
                            {{ $t('pages.configure_product.action_choose_photo') }}
                        </button>

                        <!--                        &lt;!&ndash; TODO: non va bene: h1 solo 'configura' &ndash;&gt;-->
                        <!--                        <h1 class="prod-desc&#45;&#45;header&#45;&#45;heading">-->
                        <!--                            <span class="prod-desc&#45;&#45;header&#45;&#45;heading&#45;&#45;eyebrow">{{ selectedProduct.family_name }}</span>-->
                        <!--                            {{ productTitle }}-->
                        <!--                            <span class="prod-desc&#45;&#45;header&#45;&#45;heading&#45;&#45;subheading">{{ selectedProduct.subtitle }}</span>-->
                        <!--                        </h1>-->
                        <!--                        <p class="prod-desc&#45;&#45;header&#45;&#45;desc">-->
                        <!--                            <vue-markdown>{{ selectedProduct.description }}</vue-markdown>-->
                        <!--                        </p>-->
                        <!--                        <div class="prod-desc&#45;&#45;header&#45;&#45;cta" v-if="! hasProductItems">-->
                        <!--                            <button class="btn btn-primary" @click="showPhotoChooser">{{ $t('pages.configure_product.action_choose_photo') }}</button>-->
                        <!--                        </div>-->
                    </div>
<!--                    <div>-->
                    <div class="print-product__image-container d-none d-md-block">
                        <img class="box-shadow img-fluid rounded" :src="productCoverImage">
                    </div>
                        <!--                        <div class="prod-desc&#45;&#45;header&#45;&#45;heading&#45;&#45;img">-->
                        <!--                            <img :src="productCoverImage">-->
                        <!--                        </div>-->
<!--                    </div>-->
                </section>
            </div>
        </div>

        <template v-if="hasProductItems">
            <section> <!--  class="_cart-section--print" -->
                <header class="heading-desc">
                    <div class="heading-desc--heading _two-column">
                        <h2 class="heading-desc--title">{{ $t('pages.configure_product.selected_photos_title') }}</h2>
                    </div>
                </header>
                <!--                <div class="_cart-section&#45;&#45;content">-->
                <ProductItemConfiguratorCartItem
                        :productItems="productItems"
                        :photos="photos"
                        @decrement-quantity="decrementQuantity"
                        @increment-quantity="incrementQuantity"
                        @remove-product-item="removeProductItem"
                />

                <footer> <!-- class="_cart-section--footer" -->
                    <div class="d-flex justify-content-between"> <!-- _cart-section--footer--content -->
                        <button class="btn--add" @click="showPhotoChooser"> <!-- cart-section--footer--content--btn -->
                            <img src="@/assets/icon-add.svg">
                            {{ $t('pages.configure_product.action_add_other_photos') }}
                        </button>

                        <button class="btn btn-primary" @click="saveToCart"> <!-- _cart-section--footer--cta -->
                            {{ saveButtonText }}
                        </button>
                    </div>
                </footer>
                <!--                </div>-->
            </section>
        </template>

        <!--<div class="print-items-configurator&#45;&#45;first-selection" v-else @click="showPhotoChooser">-->
        <!--<div class="print-items-configurator&#45;&#45;first-selection&#45;&#45;heading">-->
        <!--<div class="print-items-configurator&#45;&#45;first-selection&#45;&#45;btn-wrapper">-->
        <!--<img class="print-items-configurator&#45;&#45;first-selection&#45;&#45;btn-wrapper&#45;&#45;icon" src="@/assets/icon-add-photo.svg">-->
        <!--</div>-->
        <!--<div class="print-items-configurator&#45;&#45;first-selection&#45;&#45;title">{{ $t('pages.configure_product.no_photos_choosed_title') }}</div>-->
        <!--<div class="print-items-configurator&#45;&#45;first-selection&#45;&#45;txt">{{ $t('pages.configure_product.no_photos_choosed_text') }}</div>-->
        <!--</div>-->
        <!--<div class="print-items-configurator&#45;&#45;first-selection&#45;&#45;cta"><a href="" @click.prevent="showPhotoChooser">{{ $t('pages.configure_product.action_add_photo') }}</a></div>-->
        <!--</div>-->

        <!--<div v-if="hasProductItems" class="product-item-summary">-->
        <!--<div>-->
        <!--<button class="btn btn-primary" @click="saveToCart">{{ saveButtonText }}</button>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>


<script>
    // import Swal from 'sweetalert2'
    import VueMarkdown from 'vue-markdown'
    import PrintService from "@/services/Print.js"
    import ProductItemConfiguratorCartItem from "@/components/ProductItemConfiguratorCartItem.vue"

    export default {
        components: {
            VueMarkdown,
            ProductItemConfiguratorCartItem
        },
        data() {
            return {
                printItemId: null,

                /*
                oggetto <photo id>: <photo>
                popolato dal PhotoChooser, viene utilizzato come storage delle foto da mostrare
                */
                photos: {},

                /*
                oggetto <photo id>: <photo item>
                */
                productItems: {}
            }
        },

        computed: {
            isEditMode() {
                return this.printItemId !== null
            },

            selectedProduct() {
                return this.$store.getters['prints/getSelectedProduct']
            },

            productTitle() {
                if (this.selectedProduct)
                    return `${this.selectedProduct.title} ${this.$store.state.prints.selectedProductVariantOptionFormat.name}`
                return ''
            },

            productCoverImage() {
                if (this.selectedProduct.gallery.length > 0)
                    return this.selectedProduct.gallery[0].image
                return ''
            },

            productItemsIds() {
                return Object.keys(this.productItems)
            },

            hasProductItems() {
                return this.productItemsIds.length > 0
            },

            priceTotal() {
                let total = 0
                for (const photoId in this.productItems) {
                    let photo = this.productItems[photoId]
                    total += photo.price
                }
                return total
            },

            saveButtonText() {
                const i18nKey = this.isEditMode ? 'pages.configure_product.action_product_update' : 'pages.configure_product.action_product_add'
                return this.$t(i18nKey)
            }
        },

        methods: {
            showPhotoChooser() {
                let params = {'multipleSelection': true}
                // se ci sono delle foto selezionate, non permettere la loro deselezione
                if (this.hasProductItems) {
                    params['initialSelectedIds'] = this.productItemsIds
                }
                console.log('params', params)
                //this.$store.dispatch('prints/openPhotoChooser', params)
                this.$store.commit('prints/OPEN_PHOTO_CHOOSER', params)
                this.$store.commit('SET_NO_SCROLL')
            },

            loadFromPrintItem(printItem) {
                console.log('loadFromPrintItem', printItem)

                printItem.photos.forEach(item => {
                    console.log('item', item)
                    this.$set(this.photos, item.id, item)

                    // rimuovo l'object photo espanso per allineare l'object alla response della createProductConfiguration
                    const itemClone = Object.assign({}, item)
                    delete itemClone.photo
                    this.$set(this.productItems, item.id, itemClone)
                })

                this.printItemId = printItem.id
            },

            getProductConfigurationBody() {
                // ogni componente sa come costruire il body per la sua product family
                let body = {
                    'product_id': this.$store.state.prints.selectedProductId,
                    'variant_option_ids': [this.$store.state.prints.selectedProductVariantOptionFormat.id],
                    'product_configuration': {
                        'photos': []
                    }
                }

                for (const photoId in this.photos) {
                    let quantity = 1
                    if (photoId in this.productItems) {
                        quantity = this.productItems[photoId].quantity
                    }
                    body.product_configuration.photos.push({
                        'photo_id': this.photos[photoId].id,  // non uso photoId perchè è una stringa e la chiamata
                        'quantity': quantity,
                    })
                }
                return body
            },

            /*
            * Invocata al click su 'conferma' del PhotoChooser
            * Prende come input le foto selezionate
            * */
            setAndDecoratePhotos(photos) {
                console.log('setAndDecoratePhotos', photos)
                // salvo le foto in arrivo dal PhotoChooser, così le attingerò da qui per mostrarle
                this.photos = Object.assign({}, this.photos, photos)

                const body = this.getProductConfigurationBody()

                return PrintService.decorateProductConfiguration(body)
                    .then(response => {
                        console.log('createProductConfiguration response.data', response.data)
                        for (const item of response.data.photos) {
                            this.$set(this.productItems, item.photo_id, item)
                        }
                        return response
                    })
                    .catch(function (error) {
                        console.log(error)
                        return error
                    })
            },

            incrementQuantity(photoId) {
                let productItem = this.productItems[photoId]
                productItem.quantity += 1
                productItem.price = productItem.price_unit * productItem.quantity
            },

            decrementQuantity(photoId) {
                let productItem = this.productItems[photoId]
                if (productItem.quantity > 1) {
                    productItem.quantity -= 1
                    productItem.price = productItem.price_unit * productItem.quantity
                }
            },

            removeProductItem(photoId) {
                // TODO: aggiungere confirm: 'stai per rimuovere la foto: sei sicuro?')
                console.log('removeProductItem(photoId)', photoId, this.productItems)
                this.$delete(this.photos, photoId + '')
                this.$delete(this.productItems, photoId + '')
            },

            saveToCart() {
                let body = this.getProductConfigurationBody()

                console.log('saveToCart body', body)
                // return false
                // /* eslint-disable */

                if (this.isEditMode) {
                    this.$store.dispatch('cart/updatePrintItem', {
                        printItemId: this.printItemId,
                        product_configuration: body
                    }).then(() => {
                        // this.$noty.success(this.$t('notifications.print_item_updated'))
                        this.$bvToast.toast(this.$t('notifications.print_item_updated'), {
                            variant: 'success',
                            autoHideDelay: 10000,
                            noCloseButton: true,
                            toaster: 'b-toaster-top-center'
                        })
                        this.$router.push({name: 'checkout'})
                    })

                } else {
                    this.$store.dispatch('cart/addPrintItemToCart', body).then(() => {
                        // this.$store.commit('prints/RESET_PRODUCT_SELECTED')
                        this.$router.push({name: 'configuration-finished'})
                    })
                }
            },
        }
    }
</script>
